/* eslint-disable max-len */
import { useTranslation } from 'react-i18next'
import { Typography, Row, Col, Card, Space, Button } from 'antd'
import PageTitle from './PageTitle'

const { Title, Paragraph } = Typography

const PrivacyPolicy = () => {
  const { i18n } = useTranslation()
  const lang = i18n.resolvedLanguage

  return (
    <Row justify="center" style={{ minHeight: '100vh', background: '#f6f6f6', paddingTop: 40 }}>
      <PageTitle title={lang === 'de' ? 'Datenschutzerklärung – Colozoo' : 'Privacy Policy – Colozoo'} />
      <Col xs={24} md={20} lg={16}>
        {/* Language Switcher */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
          <Space>
            <Button
              type={lang === 'de' ? 'primary' : 'default'}
              size="small"
              onClick={() => i18n.changeLanguage('de')}
            >
              Deutsch
            </Button>
            <Button
              type={lang === 'en' || lang === 'en-US' ? 'primary' : 'default'}
              size="small"
              onClick={() => i18n.changeLanguage('en-US')}
            >
              English
            </Button>
          </Space>
        </div>
        <Card style={{ borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: 32, marginBottom: 42 }}>
          {lang === 'de' ? (
            <>
              <Title level={1}>Datenschutzerklärung</Title>
              <Paragraph>
                Verantwortlicher gemäß DSGVO:<br />
                <b>Viridian GmbH</b><br />
                vertreten durch Ilia Zonov<br />
                Burgstr. 1, 06114 Halle (Saale), Deutschland<br />
                E-Mail: support@colozoo.de
              </Paragraph>
              <Title level={2}>Allgemeines zur Datenverarbeitung</Title>
              <Paragraph>
                Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Personenbezogene Daten werden auf dieser Website nur im notwendigen Umfang erhoben. Ihre Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
              </Paragraph>
              <Title level={2}>Erhebung und Verarbeitung personenbezogener Daten</Title>
              <Paragraph>
                Wir erheben personenbezogene Daten, wenn Sie unser Review-Formular ausfüllen. Die erhobenen Daten umfassen insbesondere Name, E-Mail-Adresse, Adresse, Bestellnummer, gewünschtes Produkt und Ihre Einwilligung zur Datenverarbeitung und ggf. Marketing.
              </Paragraph>
              <Paragraph>
                Bei der Registrierung eines Benutzerkontos erheben wir Ihre E-Mail-Adresse und ein von Ihnen gewähltes Passwort. Diese Daten werden in unserem Firebase-System gespeichert und dienen der Authentifizierung und Verwaltung Ihres Zugangs zu unseren Online-Kursen. Zusätzlich speichern wir in Ihrem Benutzerprofil Informationen über Ihre erworbenen Kurse (Kursname und Bestellnummer).
              </Paragraph>
              <Paragraph>
                Die Verarbeitung erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) und dient dem Zweck der Bearbeitung Ihrer Anfrage und ggf. für Marketingzwecke, sowie der Bereitstellung unserer Dienstleistungen.
              </Paragraph>
              <Paragraph>
                Die Daten werden für 3 Jahre gespeichert und anschließend gelöscht.
              </Paragraph>
              <Title level={2}>Cookies & Analyse-Tools</Title>
              <Paragraph>
                Wir verwenden Cookies für die Sprachumschaltung (i18n) und Firebase Analytics, um die Nutzung unserer Website zu analysieren. Firebase Analytics ist ein Dienst der Google LLC (USA). Es kann nicht ausgeschlossen werden, dass Daten in die USA übertragen werden. Die Nutzung erfolgt auf Grundlage Ihrer Einwilligung.
              </Paragraph>
              <Title level={2}>Weitergabe und Übermittlung von Daten</Title>
              <Paragraph>
                Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, außer an Dienstleister wie Firebase Analytics, die ggf. Daten außerhalb der EU verarbeiten.
              </Paragraph>
              <Title level={2}>Ihre Rechte</Title>
              <Paragraph>
                Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie das Recht, Ihre Einwilligung jederzeit zu widerrufen. Wenden Sie sich dazu an support@colozoo.de.
              </Paragraph>
              <Title level={2}>Widerruf der Einwilligung</Title>
              <Paragraph>
                Sie können Ihre Einwilligung zur Verarbeitung personenbezogener Daten jederzeit mit Wirkung für die Zukunft widerrufen. Schreiben Sie uns dazu eine E-Mail an support@colozoo.de.
              </Paragraph>
              <Title level={2}>Kontakt</Title>
              <Paragraph>
                Bei Fragen zum Datenschutz wenden Sie sich bitte an support@colozoo.de.
              </Paragraph>
            </>
          ) : (
            <>
              <Title level={1}>Privacy Policy</Title>
              <Paragraph>
                Controller according to GDPR:<br />
                <b>Viridian GmbH</b><br />
                represented by Ilia Zonov<br />
                Burgstr. 1, 06114 Halle (Saale), Germany<br />
                Email: support@colozoo.de
              </Paragraph>
              <Title level={2}>General Information</Title>
              <Paragraph>
                We take the protection of your personal data very seriously. Personal data is collected on this website only to the extent necessary. Your data will not be passed on to third parties without your explicit consent.
              </Paragraph>
              <Title level={2}>Collection and Processing of Personal Data</Title>
              <Paragraph>
                We collect personal data when you fill out our review form. The data collected includes, in particular, your name, email address, address, order number, desired product, and your consent to data processing and, if applicable, marketing.
              </Paragraph>
              <Paragraph>
                When registering a user account, we collect your email address and a password chosen by you. This data is stored in our Firebase system and serves authentication and management of your access to our online courses. Additionally, we store information about your purchased courses (course name and order number) in your user profile.
              </Paragraph>
              <Paragraph>
                Processing is based solely on your consent (Art. 6 para. 1 lit. a GDPR) and serves the purpose of handling your request and, if applicable, for marketing purposes, as well as providing our services.
              </Paragraph>
              <Paragraph>
                Data is stored for 3 years and then deleted.
              </Paragraph>
              <Title level={2}>Cookies & Analytics</Title>
              <Paragraph>
                We use cookies for language selection (i18n) and Firebase Analytics to analyze the use of our website. Firebase Analytics is a service provided by Google LLC (USA). It cannot be ruled out that data may be transferred to the USA. Use is based on your consent.
              </Paragraph>
              <Title level={2}>Disclosure and Transfer of Data</Title>
              <Paragraph>
                Your data will not be shared with third parties except for service providers such as Firebase Analytics, which may process data outside the EU.
              </Paragraph>
              <Title level={2}>Your Rights</Title>
              <Paragraph>
                You have the right to access, rectify, erase, restrict processing, data portability, and the right to withdraw your consent at any time. Please contact support@colozoo.de for this purpose.
              </Paragraph>
              <Title level={2}>Withdrawal of Consent</Title>
              <Paragraph>
                You can withdraw your consent to the processing of personal data at any time with effect for the future. To do so, please email support@colozoo.de.
              </Paragraph>
              <Title level={2}>Contact</Title>
              <Paragraph>
                If you have any questions about data protection, please contact support@colozoo.de.
              </Paragraph>
            </>
          )}
        </Card>
      </Col>
    </Row>
  )
}

export default PrivacyPolicy
